const stats = [
  { value: "99%",      label: "COVERAGE" },
  { value: "5G",       label: "SPEED"    },
  { value: "Premium",  label: "DATA"     },
  { value: "Included", label: "HOTSPOT"  },
];

const NetworkSection = () => {
  return (
    <section
      className="w-full py-16 lg:py-24 border-t"
      style={{ backgroundColor: '#13131f', borderColor: 'rgba(255,255,255,0.08)' }}
    >
      <div className="container mx-auto px-4 text-center" style={{ maxWidth: '1200px' }}>

        <h2
          className="text-white font-bold mb-4"
          style={{
            fontSize: 'clamp(32px, 5vw, 60px)',
            lineHeight: 1.1,
            letterSpacing: '-0.04em',
          }}
        >
          Powered by the best.
        </h2>
        <p
          className="mx-auto mb-12"
          style={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: 'clamp(15px, 2vw, 18px)',
            lineHeight: 1.6,
            maxWidth: '560px',
          }}
        >
          Enjoy lightning-fast 5G data and reliable coverage across the nation on AT&T's premier network.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          {stats.map(({ value, label }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center rounded-2xl px-10 py-6"
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                minWidth: '160px',
              }}
            >
              <span
                className="font-bold mb-1"
                style={{ color: '#B0F18D', fontSize: 'clamp(28px, 3vw, 40px)', letterSpacing: '-0.03em' }}
              >
                {value}
              </span>
              <span
                className="font-semibold tracking-widest"
                style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px' }}
              >
                {label}
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NetworkSection;
